import { getApiBaseUrl } from './config'
import { trackShare } from './ga'

/** Haber paylaşım tıklaması: GA4 event + DB shareCount (cache'siz POST). */
export function recordNewsShare(
  newsId: number,
  opts?: {
    method?: string
    title?: string
    category?: string | null
  },
) {
  if (!Number.isFinite(newsId) || newsId <= 0) return

  if (opts?.title) {
    trackShare({
      articleId: newsId,
      title: opts.title,
      category: opts.category,
      method: opts.method || 'unknown',
    })
  }

  void fetch(`${getApiBaseUrl()}/api/news/${newsId}/share`, {
    method: 'POST',
    keepalive: true,
    cache: 'no-store',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
  }).catch(() => {})
}
